import request from '@/utils/request'
const apiPath = '/user/DataBoard'
const DataBoardApi = {
  /**
   * 新增【数据看板】
   */
  // 服务分析
  findServiceAnalysisStatistics(data) {
    return request.post(apiPath + '/findServiceAnalysisStatistics', data, { isFormData: 1 })
  },
  findDesignatedCustomers(data) {
    return request.post(apiPath + '/findDesignatedCustomers', data, { isFormData: 1 })
  },
  shipmentAnalysisK(query) {
    return request.get(apiPath + '/shipmentAnalysisK', { params: query })
  },
  shipmentAnalysisList(query) {
    return request.get(apiPath + '/shipmentAnalysisList', { params: query })
  },
  studySuperviseAanalysisK(query) {
    return request.get(apiPath + '/studySuperviseAanalysisK', { params: query })
  },
  // 大屏数据展示-账户支付数据分析
  findAccountStatisticsByBigSereenVO(query) {
    return request.get(apiPath + '/findAccountStatisticsByBigSereenVO', { params: query })
  },
  // 大屏数据展示-线下会议统计上半部分
  findMeetStatisticsByBigScreen(query) {
    return request.get(apiPath + '/findMeetStatisticsByBigScreen', { params: query })
  },
  //大屏数据展示-线下会议下半部分
  findMeetStatisticsDownList(query) {
    return request.get(apiPath + '/findMeetStatisticsDownList', { params: query })
  },
  //大屏数据展示-收款统计
  payStatistics(data) {
    return request.post(apiPath + '/payStatistics', data)
  },
  //数据看板 -- 会议分析
  MeetingAnalysisTotalList(data) {
    return request.post(apiPath + '/MeetingAnalysisTotalList', data, { isFormData: 1 })
  },
  //数据看板 -- 会议分析 收款统计
  MeetCollectionStatistics(data) {
    return request.post(apiPath + '/MeetCollectionStatistics', data, { isFormData: 1 })
  },
  //数据看板 -- 会议分析 出货统计
  MeetShipmentStatistics(data) {
    return request.post(apiPath + '/MeetShipmentStatistics', data, { isFormData: 1 })
  },
  payStatisticsList(data) {
    return request.post(apiPath + '/payStatisticsList', data)
  },
  //数据看板 -- 项目分析
  projecAnalysisK(query) {
    return request.get(apiPath + '/projecAnalysisK', { params: query })
  },
  //数据看板 -- 项目分析
  projecAnalysisList(query) {
    return request.get(apiPath + '/projecAnalysisList', { params: query })
  },
  //数据看板 -- 项目分析-政策类型
  projecAnalysisTypeList(query) {
    return request.get(apiPath + '/projecAnalysisTypeList', { params: query })
  },
  //数据看板 -- 线上项目分析
  onlineServiceAnalysisList(query) {
    return request.get(apiPath + '/onlineServiceAnalysisList', { params: query })
  },
  // 数据看板-线上项目分析-收款K线图
  onlineServiceAnalysisPayK(query) {
    return request.get(apiPath + '/onlineServiceAnalysisPayK', { params: query })
  },
  // 数据看板-线上项目分析-出货K线图
  onlineServiceAnalysisShipmentK(query) {
    return request.get(apiPath + '/onlineServiceAnalysisShipmentK', { params: query })
  },
  // 数据看板-人效分析-收款统计
  HumanReceiveMoneyTotal(query) {
    return request.get(apiPath + '/HumanReceiveMoneyTotal', { params: query })
  },
  // 数据看板-人效分析-服务次数统计
  HumanServiceTotal(query) {
    return request.get(apiPath + '/HumanServiceTotal', { params: query })
  },
  // 数据看板-人效分析-出货统计
  HumanShipmentTotal(query) {
    return request.get(apiPath + '/HumanShipmentTotal', { params: query })
  },
  getUserInfo(data) {
    return request.post(apiPath + '/getUserInfo', data, { isFormData: 1 })
  }

}
export default DataBoardApi
